import { FunctionComponent } from 'react';
import { Datepicker } from '@mobiscroll/react';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';

export type DateRange<T> = [T | null, T | null];

type DatePickerProps = {
    type: "Date" | "Time" | "DateAndTime" | "StaticDate" | "DateRange",
    selected: Date | null,
    label: string,
    onDateChange: Function,
    width?: number,
    errorString?: string | "",
    selectedRange?: DateRange<Date>,
    disableFuture?: boolean,
    disabled?: boolean
}

const DatePickerUI: FunctionComponent<DatePickerProps> = ({ type, disabled, disableFuture, selected, label, onDateChange, width = 100, errorString = "", selectedRange = ([null, null]) }) => {
    const handleDateChange = (newDate: Date | null) => {
        onDateChange(newDate);
    };
    const handleDateRangeChange = (newDates: DateRange<Date>) => {
        onDateChange(newDates);
    };

    const maxDate = disableFuture ? new Date() : undefined;

    return (
        <div className="ds-control-root" style={{ width: width + '%' }}>
            {type === "Date" && (
                <Datepicker
                    controls={['calendar']}
                    inputProps={{ placeholder: label }}
                    label={label}
                    display="anchored"
                    touchUi={false}
                    value={selected}
                    onChange={(e: any) => handleDateChange(e.value)}
                    themeVariant="light"
                    dateFormat="DD/MM/YYYY"
                    max={maxDate}
                    disabled={disabled}
                />
            )}

            {type === "StaticDate" && (
                <Datepicker
                    controls={['calendar']}
                    display="inline"
                    value={selected}
                    onChange={(e: any) => handleDateChange(e.value)}
                    themeVariant="light"
                    dateFormat="DD/MM/YYYY"
                    disabled={disabled}
                />
            )}

            {type === "Time" && (
                <Datepicker
                    controls={['time']}
                    inputProps={{ placeholder: label }}
                    label={label}
                    display="anchored"
                    touchUi={false}
                    value={selected}
                    onChange={(e: any) => handleDateChange(e.value)}
                    themeVariant="light"
                    timeFormat="HH:mm"
                    disabled={disabled}
                />
            )}

            {type === "DateAndTime" && (
                <Datepicker
                    controls={['calendar', 'time']}
                    inputProps={{ placeholder: label }}
                    label={label}
                    display="anchored"
                    touchUi={false}
                    value={selected}
                    onChange={(e: any) => handleDateChange(e.value)}
                    themeVariant="light"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    disabled={disabled}
                />
            )}

            {type === "DateRange" && (
                <Datepicker
                    controls={['calendar']}
                    select="range"
                    inputProps={{ placeholder: label }}
                    label={label}
                    display="anchored"
                    touchUi={false}
                    value={selectedRange}
                    onChange={(e: any) => {
                        const val = e.value as [Date | null, Date | null];
                        handleDateRangeChange(val);
                    }}
                    themeVariant="light"
                    dateFormat="DD/MM/YYYY"
                    disabled={disabled}
                />
            )}

            {errorString && (
                <p className="mt-1 text-xs text-error">{errorString}</p>
            )}
            </div>
    );
};
export default DatePickerUI